import { useAuth } from "@/contexts/AuthContext";

/**
 * Returns the current user's nursery_id.
 * Used by mutation hooks to scope inserts to the correct nursery.
 */
export function useNurseryId(): string | null {
  const { profile } = useAuth();
  return profile?.nursery_id ?? null;
}
